import { IMethod, useNavigation, useRequest, useUpdateUSCIntegration } from '~/Hooks';
import { EVENT_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { ExtendedEventGroup } from '../ExtendedEventGroup.model';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { EventGroup } from '~/Models/DTO/EventGroup.model';
import { omit } from 'lodash-es';
import { useEventGroupRequestParams } from '~/Screens/Events/EventCreate/hooks';

export const useUpdateEventGroupRequest = () => {
  const { requestWithCallback } = useRequest();
  const { goBack } = useNavigation();
  const getRequestParams = useEventGroupRequestParams();
  const { updateUSCIntegrationForEventGroup } = useUpdateUSCIntegration();

  return {
    updateEventGroup: async ({
      eventGroupToSend,
      setSubmissionError,
    }: {
      eventGroupToSend: ExtendedEventGroup;
      setSubmissionError: (error: IErrorResponse) => void;
    }) => {
      const {
        id = '',
        timeSeries,
        isUSCIntegrationEnabled,
        ...restEventGroupData
      } = omit(eventGroupToSend, [
        'publicCancellationRefundEndAsNumber',
        'hasAccessToZoom',
        'isZoomSelected',
        'isZoomWebinar',
        'publicBookingWindowStartType',
        'publicBookingWindowEndType',
        'publicCancellationRefundEndType',
        'publicCancellationWindowOpen',
      ]);

      await requestWithCallback<EventGroup>(
        getRequestParams({ eventGroups: restEventGroupData, id }),
        async () => {
          await Promise.allSettled(
            (timeSeries || []).map(({ shouldDelete, id = 'none', ...restData }) => {
              let url;
              let method: IMethod;
              let data;
              if (shouldDelete) {
                url = routeReplacer(EVENT_SERVICE_URLS.EVENT_SERIES_DETAIL, { id });
                method = 'DELETE';
              } else if (id === 'none') {
                url = EVENT_SERVICE_URLS.EVENT_SERIES;
                method = 'POST';
                data = restData;
              } else {
                url = routeReplacer(EVENT_SERVICE_URLS.EVENT_SERIES_DETAIL, { id });
                method = 'PUT';
                data = { ...restData, id };
              }

              return requestWithCallback({ url, method, data });
            }),
          );

          await updateUSCIntegrationForEventGroup({ eventGroupId: id, isUSCIntegrationEnabled });

          goBack();
        },
        (error) => {
          setSubmissionError(error);
        },
      );
    },
  };
};
